export default __webpack_public_path__ + "static/media/eIcon2.11aad94b.svg";